import { render, staticRenderFns } from "./ApprovalDutiesList.vue?vue&type=template&id=07a17d85"
import script from "./ApprovalDutiesList.vue?vue&type=script&lang=js"
export * from "./ApprovalDutiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports